import * as ActionTypes from "../Types/ActionTypes";

export const ProjectStages = (
  state = {
    isLoading: true,
    errMess: null,
    projectStages: [],
  },
  action
) => {
  switch (action.type) {
    case ActionTypes.FETCH_PROJECTSTAGE:
      return {
        ...state,
        isLoading: false,
        errMess: null,
        projectStages: action.payload,
      };

    case ActionTypes.PROJECTSTAGE_LOADING:
      return {
        ...state,
        isLoading: true,
        errMess: null,
        projectStages: [],
      };

    case ActionTypes.PROJECTSTAGE_FAILED:
      return {
        ...state,
        isLoading: false,
        errMess: action.payload,
        projectStages: [],
      };

    default:
      return state;
  }
};
